import React from 'react';
import {
	BrowserRouter as Router,
	Route,
	Switch,
} from 'react-router-dom';
import './App.css';

import Extension from './routes/Extension';

import Home from './routes/Site/Home';
import PrivacyPolicy from './routes/Site/Operations/PrivacyPolicy';

import CatSnapshot from './routes/Site/CatSnapshot';

import Shop from './routes/Site/Shop';
import ShopPrivacyPolicy from './routes/Site/Operations/ShopPrivacyPolicy';
import ShopTOS from './routes/Site/Operations/ShopTOS';

import FAQ from './routes/Site/Operations/FAQ';

import NotFound from './routes/Site/NotFound';

function App() {
	const developmentMode = process.env.NODE_ENV === 'development';
	return (
		<Router>
			<Switch>
				<Route path="/" exact component={Home} />
				{developmentMode ? <Route path="/ext" exact component={Extension} /> : null}
				<Route path="/meow" exact component={CatSnapshot} />
				<Route path="/terms-of-use-and-privacy-policy" component={PrivacyPolicy} />
				<Route path="/cat/:id" component={CatSnapshot} />
				<Route path="/cat/:id/screenshot" component={CatSnapshot} />
				<Route path="/shop" exact component={Shop} />
				<Route path="/shop/privacy-policy" component={ShopPrivacyPolicy} />
				<Route path="/shop/terms-of-service" component={ShopTOS} />
				<Route path="/faq" component={FAQ} />
				<Route component={NotFound} />
			</Switch>
		</Router>
	);
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js